import type { ErrorKind, VoiceState } from "./voiceTypes";

export const VOICE_BASE = "https://voice.vinsyt.com";

export const BASE_AMPS = [0.45, 0.75, 1, 0.6, 0.9, 0.5, 0.8, 1, 0.55, 0.7, 0.4, 0.85];

export const stateConfig: Record<
  VoiceState,
  { label: string; sublabel: string; hue: number; forceHover: boolean }
> = {
  connecting: {
    label: "Connecting...",
    sublabel: "Setting up voice channel",
    hue: 0,
    forceHover: false,
  },
  listening: {
    label: "Listening",
    sublabel: "Speak now",
    hue: 0,
    forceHover: true,
  },
  speaking: {
    label: "iVin is speaking",
    sublabel: "AI is responding",
    hue: 60,
    forceHover: true,
  },
  error: {
    label: "Connection failed",
    sublabel: "",
    hue: 0,
    forceHover: false,
  },
};

export const ERROR_MESSAGES: Record<
  NonNullable<ErrorKind>,
  { title: string; detail: string; canRetry: boolean }
> = {
  mic_denied: {
    title: "Microphone access denied",
    detail: "Allow microphone access in your browser settings, then retry.",
    canRetry: false,
  },
  mic_not_found: {
    title: "No microphone found",
    detail: "Plug in a microphone and try again.",
    canRetry: true,
  },
  mic_busy: {
    title: "Microphone is in use",
    detail: "Another app is using your mic. Close it and retry.",
    canRetry: true,
  },
  mic_unavailable: {
    title: "Microphone not supported",
    detail: "Voice mode requires HTTPS and a browser with mic support.",
    canRetry: false,
  },
  network: {
    title: "Unable to reach voice server",
    detail: "Check your connection and try again.",
    canRetry: true,
  },
};

export const stateColor: Record<VoiceState, string> = {
  connecting: "#3AC1F3",
  listening: "#3AC1F3",
  speaking: "#818CF8",
  error: "#ef4444",
};

export function parseChatSessionId(raw: string): string {
  return raw.includes("-#$#-") ? raw.split("-#$#-")[1] : raw;
}

export function micErrorKind(err: unknown): ErrorKind {
  const name = (err as { name?: string })?.name ?? "";
  if (name === "NotAllowedError" || name === "PermissionDeniedError") return "mic_denied";
  if (name === "NotFoundError" || name === "DevicesNotFoundError") return "mic_not_found";
  if (name === "NotReadableError" || name === "TrackStartError") return "mic_busy";
  return "mic_unavailable";
}
